import { Store, Loader2 } from 'lucide-react';
import { DEFAULT_STORE_PRIMARY } from '@/lib/storeTheme';

export default function StoreBrandMark({ theme, loading = false, size = 48 }) {
  const primary = theme?.primary || DEFAULT_STORE_PRIMARY;
  const brandName = theme?.brandName || 'Toko';
  const logoUrl = theme?.logoUrl;

  if (loading) {
    return (
      <div className="flex justify-center mb-4">
        <Loader2 size={24} className="animate-spin text-slate-400" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center mb-4 gap-2">
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={brandName}
          className="rounded-xl object-cover shadow-sm"
          style={{ width: size, height: size }}
        />
      ) : (
        <div
          className="rounded-xl flex items-center justify-center shadow-sm"
          style={{ width: size, height: size, backgroundColor: primary }}
        >
          <Store size={Math.round(size * 0.5)} className="text-white" />
        </div>
      )}
      {theme?.brandName && (
        <p className="text-sm font-semibold text-slate-700">{theme.brandName}</p>
      )}
    </div>
  );
}
